import http from './http'

export default {
    all() {
        return http.get('hsbc/contactos')
    },
    update(contacto, payload){
        return http.put(`hsbc/contactos/${contacto}`, payload)
    },

    addComment(contacto, contenido) {
        return http.post(`hsbc/contactos/${contacto}/comentarios`, {
            contenido
        })
    },
}